



















































































import { Component, Vue, Watch } from "vue-property-decorator";
import { storeSupervisiCssd } from "@/store/modules/SupervisiCssdStore";
import SupervisiCssdSvc from "@/services/SupervisiCssdService";

@Component({})
export default class SupervisiCssdListPage extends Vue {
  filter = {
    tanggal_dari: "",
    tanggal_sampai: "",
    signed: null as boolean | null,
  };

  signedOpts = [
    { text: "Sudah TTD lengkap", value: true },
    { text: "Belum final", value: false },
  ];

  pagination = {
    page: 1,
    itemsPerPage: 15,
  };

  headers = [
    { text: "Nomor Formulir", value: "nomor_formulir" },
    { text: "Tanggal", value: "tanggal_supervisi" },
    { text: "Supervisor", value: "supervisor", sortable: false },
    { text: "Status", value: "status", sortable: false },
    { text: "Aksi", value: "actions", sortable: false, align: "end" },
  ];

  get items() {
    return storeSupervisiCssd.items;
  }

  get loading() {
    return storeSupervisiCssd.loading;
  }

  get meta() {
    return storeSupervisiCssd.meta;
  }

  mounted() {
    this.fetch();
  }

  @Watch("pagination", { deep: true })
  onPagination() {
    this.fetch();
  }

  fetch() {
    const params: any = {
      page: this.pagination.page,
      per_page: this.pagination.itemsPerPage,
    };
    if (this.filter.tanggal_dari) params.tanggal_dari = this.filter.tanggal_dari;
    if (this.filter.tanggal_sampai) params.tanggal_sampai = this.filter.tanggal_sampai;
    if (this.filter.signed !== null && this.filter.signed !== undefined) {
      params.signed = this.filter.signed;
    }
    storeSupervisiCssd.fetchList(params);
  }

  applyFilter() {
    this.pagination.page = 1;
    this.fetch();
  }

  resetFilter() {
    this.filter = { tanggal_dari: "", tanggal_sampai: "", signed: null };
    this.applyFilter();
  }

  createNew() {
    this.$router.push({ name: "supervisi-cssd-form", params: { id: "baru" } });
  }

  openEdit(id: number) {
    this.$router.push({ name: "supervisi-cssd-form", params: { id: String(id) } });
  }

  printPdf(id: number) {
    SupervisiCssdSvc.printPdf(id);
  }

  formatDate(d: string) {
    if (!d) return "-";
    const [y, m, day] = d.split("-");
    return `${day}-${m}-${y}`;
  }
}
